import { useMatch, useParams } from 'react-router-dom';

export interface UseJobIdResult {
  jobId: string;
}

export const useJobId = (): UseJobIdResult => {
  const match = useMatch('/:lang?/job/:id/*');
  const { id } = useParams();
  const jobId = id || match?.params.id;

  if (!jobId) {
    throw new Error('No job id found in url');
  }

  return {
    jobId,
  };
};
